import React from 'react';

import { Arrow, RenderLayerProps } from 'react-laag';

import Dropdown from 'components/shared/Dropdown';

export const PopoverLayer = function ({
  layerProps,
  arrowStyle,
  layerSide,
  children,
  isOpen,
}: React.PropsWithChildren<RenderLayerProps>) {
  if (!isOpen) return null;

  return (
    // TODO: delete zindex after fixing the issue with the modals
    <div ref={layerProps.ref} style={{ ...layerProps.style, zIndex: 999999999 }}>
      <Dropdown>{children}</Dropdown>
      <Arrow
        style={{ ...arrowStyle, zIndex: '22' }}
        layerSide={layerSide}
        borderWidth={1}
        borderColor="rgba(0, 0, 0, 0.04)"
        backgroundColor="#fff"
        angle={50}
        roundness={0.5}
        size={6}
      />
    </div>
  );
};
